import { AppInsightsEvents } from "../../enums/AppInsightsEvents";
import { appInsightsPromise } from "../../services/ApplicationInsightsService";
import { clearCookies } from "../utils";
import { getB2CLogoutUrl } from "./b2cRedirectUtils";
import { IPublicClientApplication } from "@azure/msal-browser";

export interface LogoutParams {
  configData: Record<string, unknown>;
  userSpecialtyTypeId: number;
  instance: IPublicClientApplication;
  onComplete?: () => void;
}

export function performLogout({
  configData,
  userSpecialtyTypeId: specialtyTypeId,
  instance,
  onComplete,
}: LogoutParams) {
  const accounts = instance.getAllAccounts();
  const firstAccount = accounts[0];
  if (!firstAccount) {
    console.error("No account found for logout");
    if (onComplete) onComplete();
    return;
  }
  const logoutRequest = {
    account: firstAccount,
    postLogoutRedirectUri: getB2CLogoutUrl(configData, specialtyTypeId),
    idTokenHint: firstAccount.idToken,
  };

  // Track user logout event in app insights
  appInsightsPromise
    .then((appInsights) => {
      if (appInsights && firstAccount) {
        const additionalProperties = {
          Name: firstAccount.name,
          "User ID": firstAccount.username,
        };
        appInsights.trackEvent(
          { name: AppInsightsEvents.UserLogoutEvent },
          additionalProperties,
        );
      }
    })
    .catch((error) => {
      console.warn(
        "Error tracking logout event in Application Insights:",
        error,
      );
    })
    .finally(() => {
      clearCookies();
      sessionStorage.clear();
      instance.logoutRedirect(logoutRequest);
      if (onComplete) onComplete();
    });
}
